<template>
  <div class="usage-box">
    <div class="label--xsmall">
      Usage resets
    </div>
    <div class="usage-reset heading--small">
      {{ formatted }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoUsageResets",
  props: { resetDate: { type: [String, Date], default: null } },
  computed: {
    formatted() {
      if (!this.resetDate) return "";
      return new Date(this.resetDate).toLocaleDateString(
        undefined, {
          month: "short", 
          day: "numeric", 
          year: "numeric"
        }
      );
    }
  }
};
</script>

<style lang="scss">
.usage-box {
  @include inset-space($space-medium);
  @include stack-space($space-medium);
  background: $color-background-secondary;
  border-radius: $radius-small;
  text-align: center;
  .usage-reset { color: $color-text-primary; }
}
</style>
